import BaseButton from 'Components/Base/BaseButton';
import BaseInput from 'Components/Base/BaseInput';
import { BaseSelect } from 'Components/Base/BaseSelect';
import { NewLabel } from 'Components/constants/Role';
import { InputPlaceHolder, SelectPlaceHolder } from 'Components/constants/validation';
import React from 'react'
import { FormikProps } from "formik";
import { QuotationLabel } from 'Components/constants/Quotation';
import { ProductErrorMessage } from 'Components/constants/Common';
interface FormFieldsProps {
  formik: FormikProps<any>;
  vendorOption: Array<any>;
  productOption: Array<any>;
  serviceOption: Array<any>;
  handleVendorChange: any;
  viewQuotationMode: boolean;
  quotationId: any;
  quotationData: any;
  setSelectedVendorData: any;
  setInitialValue: any;
  selectedProducts: any;
}
const FormFields: React.FC<FormFieldsProps> = ({
  formik,
  vendorOption,
  productOption,
  serviceOption,
  handleVendorChange,
  viewQuotationMode,
  quotationId,
  quotationData,
  setSelectedVendorData,
  setInitialValue,
  selectedProducts,
}) => {
  return (
    <form onSubmit={formik.handleSubmit} className="mt-2 mb-4">
      <div className="row">
        <div className="col-md-3 col-sm-6 col-12">
          <BaseSelect
            name="vendorName"
            label={QuotationLabel.VendorName}
            options={vendorOption}
            placeholder={SelectPlaceHolder(QuotationLabel.VendorName)}
            value={formik.values.vendorName}
            handleChange={(field: any, value: any) => {
              formik.setFieldValue(field, value);
              if (value) {
                handleVendorChange(value);
                setInitialValue(false);
              } else {
                setSelectedVendorData(null);
              }
            }}
            handleBlur={formik.handleBlur}
            error={formik.errors.vendorName}
            touched={formik.touched.vendorName}
            isDisabled={viewQuotationMode}
            required
            addOptionLabel={QuotationLabel.AddCustomer}
          />
        </div>
        <div className="col-md-3 col-sm-6 col-12">
          <BaseInput
            name="vendorId"
            label={QuotationLabel.VendorId}
            placeholder={InputPlaceHolder(QuotationLabel.VendorId)}
            value={formik.values.vendorId}
            onChange={formik.handleChange}
            handleBlur={formik.handleBlur}
            error={formik.errors.vendorId}
            touched={formik.touched.vendorId}
            disabled={true}
            required
          />
        </div>
        <div className="col-md-3 col-sm-6 col-12">
          <BaseInput
            type="textarea"
            name="consignee_address"
            label={QuotationLabel.Consignee}
            placeholder={InputPlaceHolder(QuotationLabel.Consignee)}
            value={formik.values.consignee_address}
            onChange={formik.handleChange}
            handleBlur={formik.handleBlur}
            error={formik.errors.consignee_address}
            touched={formik.touched.consignee_address}
            disabled={viewQuotationMode}
            required
          />
        </div>
        <div className="col-md-3 col-sm-6 col-12">
          <BaseInput
            type="textarea"
            name="buyer_address"
            label={QuotationLabel.Buyer}
            placeholder={InputPlaceHolder(QuotationLabel.Buyer)}
            value={formik.values.buyer_address}
            onChange={formik.handleChange}
            handleBlur={formik.handleBlur}
            error={formik.errors.buyer_address}
            touched={formik.touched.buyer_address}
            disabled={viewQuotationMode}
            required
          />
        </div>
      </div>
      <div className="row mt-2">
        <div className="col-md-3 col-sm-6 col-12">
          <BaseInput
            type="date"
            name="dated"
            label={QuotationLabel.Dated}
            placeholder={InputPlaceHolder(QuotationLabel.Dated)}
            value={formik.values.dated}
            onChange={formik.handleChange}
            handleBlur={formik.handleBlur}
            error={formik.errors.dated}
            touched={formik.touched.dated}
            disabled={viewQuotationMode}
            required
          />
        </div>
        <div className="col-md-3 col-sm-6 col-12">
          <BaseInput
            name="modeOfPayment"
            label={QuotationLabel.ModesOfPayment}
            placeholder={InputPlaceHolder(QuotationLabel.ModesOfPayment)}
            value={formik.values.modeOfPayment}
            onChange={formik.handleChange}
            handleBlur={formik.handleBlur}
            error={formik.errors.modeOfPayment}
            touched={formik.touched.modeOfPayment}
            disabled={viewQuotationMode}
          />
        </div>
        <div className="col-md-3 col-sm-6 col-12">
          <BaseInput
            name="buyerRefNo"
            label={QuotationLabel.BuyerRefNo}
            placeholder={InputPlaceHolder(QuotationLabel.BuyerRefNo)}
            value={formik.values.buyerRefNo}
            onChange={formik.handleChange}
            handleBlur={formik.handleBlur}
            error={formik.errors.buyerRefNo}
            touched={formik.touched.buyerRefNo}
            disabled={viewQuotationMode}
          />
        </div>
        <div className="col-md-3 col-sm-6 col-12">
          <BaseInput
            type="date"
            name="buyerRefDate"
            label={QuotationLabel.BuyerRefDate}
            placeholder={InputPlaceHolder(QuotationLabel.BuyerRefDate)}
            value={formik.values.buyerRefDate}
            onChange={formik.handleChange}
            handleBlur={formik.handleBlur}
            error={formik.errors.buyerRefDate}
            touched={formik.touched.buyerRefDate}
            disabled={viewQuotationMode}
          />
        </div>
      </div>
      <div className="row mt-2">
        <div className="col-md-3 col-sm-6 col-12">
          <BaseInput
            name="vehicleRegNo"
            label={QuotationLabel.VehicleRegNo}
            placeholder={InputPlaceHolder(QuotationLabel.VehicleRegNo)}
            value={formik.values.vehicleRegNo}
            onChange={formik.handleChange}
            handleBlur={formik.handleBlur}
            error={formik.errors.vehicleRegNo}
            touched={formik.touched.vehicleRegNo}
            disabled={viewQuotationMode}
          />
        </div>
        <div className="col-md-3 col-sm-6 col-12">
          <BaseInput
            name="chassisNo"
            label={QuotationLabel.ChassisNo}
            placeholder={InputPlaceHolder(QuotationLabel.ChassisNo)}
            value={formik.values.chassisNo}
            onChange={formik.handleChange}
            handleBlur={formik.handleBlur}
            error={formik.errors.chassisNo}
            touched={formik.touched.chassisNo}
            disabled={viewQuotationMode}
          />
        </div>
        <div className="col-md-3 col-sm-6 col-12">
          <BaseInput
            name="engineNo"
            label={QuotationLabel.EngineNo}
            placeholder={InputPlaceHolder(QuotationLabel.EngineNo)}
            value={formik.values.engineNo}
            onChange={formik.handleChange}
            handleBlur={formik.handleBlur}
            error={formik.errors.engineNo}
            touched={formik.touched.engineNo}
            disabled={viewQuotationMode}
          />
        </div>
        <div className="col-md-3 col-sm-6 col-12">
          <BaseInput
            name="destination"
            label={QuotationLabel.Destination}
            placeholder={InputPlaceHolder(QuotationLabel.Destination)}
            value={formik.values.destination}
            onChange={formik.handleChange}
            handleBlur={formik.handleBlur}
            error={formik.errors.destination}
            touched={formik.touched.destination}
            disabled={viewQuotationMode}
          />
        </div>
      </div>
      <div className="row mt-2">
        <div className="col-md-3 col-sm-6 col-12">
          <BaseInput
            name="otherRef"
            label={QuotationLabel.OtherRef}
            placeholder={InputPlaceHolder(QuotationLabel.OtherRef)}
            value={formik.values.otherRef}
            onChange={formik.handleChange}
            handleBlur={formik.handleBlur}
            error={formik.errors.otherRef}
            touched={formik.touched.otherRef}
            disabled={viewQuotationMode}
          />
        </div>
        <div className="col-md-3 col-sm-6 col-12">
          <BaseInput
            name="warranty"
            label={QuotationLabel.Warranty}
            placeholder={InputPlaceHolder(QuotationLabel.Warranty)}
            value={formik.values.warranty}
            onChange={formik.handleChange}
            handleBlur={formik.handleBlur}
            error={formik.errors.warranty}
            touched={formik.touched.warranty}
            disabled={viewQuotationMode}
          />
        </div>
        <div className="col-md-3 col-sm-6 col-12">
          <BaseInput
            type="textarea"
            name="termsOfDelivery"
            label={QuotationLabel.TermsOfDelivery}
            placeholder={InputPlaceHolder(QuotationLabel.TermsOfDelivery)}
            value={formik.values.termsOfDelivery}
            onChange={formik.handleChange}
            handleBlur={formik.handleBlur}
            error={formik.errors.termsOfDelivery}
            touched={formik.touched.termsOfDelivery}
            disabled={viewQuotationMode}
          />
        </div>
        <div className="col-md-3 col-sm-6 col-12">
          <BaseInput
            type="number"
            name="discount"
            label={QuotationLabel.Discount}
            placeholder={InputPlaceHolder(QuotationLabel.Discount)}
            value={formik.values.discount}
            onChange={(e) => {
              if (Number(e.target.value) < 100) {
                formik.handleChange(e);
                setInitialValue(false);
              }
            }}
            handleBlur={formik.handleBlur}
            error={formik.errors.discount}
            touched={formik.touched.discount}
            disabled={viewQuotationMode}
          />
        </div>
        {quotationId && (
          <div className="col-md-3 col-sm-6 col-12">
            <BaseInput
              name="quoteStatus"
              label={QuotationLabel.Status}
              placeholder={InputPlaceHolder(QuotationLabel.Status)}
              value={formik.values.quoteStatus}
              onChange={formik.handleChange}
              handleBlur={formik.handleBlur}
              error={formik.errors.quoteStatus}
              touched={formik.touched.quoteStatus}
              disabled={true}
            />
          </div>
        )}
        {quotationData?.status === QuotationLabel.Rejected && (
          <div className="col-md-3 col-sm-6 col-12">
            <BaseInput
              type="textarea"
              name="remarks"
              label={QuotationLabel.Remarks}
              placeholder={InputPlaceHolder(QuotationLabel.Remarks)}
              value={formik.values.remarks}
              onChange={formik.handleChange}
              handleBlur={formik.handleBlur}
              error={formik.errors.remarks}
              touched={formik.touched.remarks}
              disabled={true}
            />
          </div>
        )}
      </div>
      <div className="w-full border-bottom mt-3 mb-1"></div>
      {!viewQuotationMode && (
        <div className="align-items-center mx-2">
          <div className="mt-2">
          <div className="row">
            <div className="col-md-3 col-sm-6 col-12">
              <BaseSelect
                name="product"
                label={QuotationLabel.Product}
                options={productOption}
                value={formik.values.product}
                placeholder={SelectPlaceHolder(QuotationLabel.Product)}
                handleChange={(field: any, value: any) => {
                  formik.setFieldValue(field, value);
                  setInitialValue(false);
                }}
                handleBlur={formik.handleBlur}
                error={formik.errors.product}
                touched={formik.touched.product}
                isDisabled={viewQuotationMode}
                required={!viewQuotationMode && !quotationId}
                addOptionLabel={QuotationLabel.AddProduct}
                />
              </div>
              <div className="col-md-3 col-sm-6 col-12">
              <BaseSelect
                name="service"
                label={QuotationLabel.Service}
                options={serviceOption}
                value={formik.values.service}
                placeholder={SelectPlaceHolder(QuotationLabel.Service)}
                handleChange={(field: any, value: any) => {
                  formik.setFieldValue(field, value);
                }}
                handleBlur={formik.handleBlur}
                error={formik.errors.service}
                touched={formik.touched.service}
                isDisabled={viewQuotationMode}
                required={!viewQuotationMode && !quotationId}
                addOptionLabel={QuotationLabel.AddService}
                />
                </div>
            </div>
            {selectedProducts?.length < 1 &&
              (formik.values.product === null ||
                formik.values.service === null) && (
                <span className="text-danger mt-2">{ProductErrorMessage}</span>
              )}
          </div>
        </div>
      )}
    </form>
  );
};

export default FormFields